import { compare } from 'compare-versions';

export const SEMVER = {
  compare: compare,
};
